import { RefObject, useEffect, useMemo, useState } from 'react';

export const useOnScreen = (
  ref: RefObject<HTMLDivElement | HTMLSpanElement | null | undefined>
) => {
  const [isIntersecting, setIntersecting] = useState(false);

  const observer = useMemo(
    () =>
      new IntersectionObserver((entries) => {
        if (entries[0]) {
          const { isIntersecting } = entries[0];
          setIntersecting(isIntersecting);
        }
      }),
    []
  );

  useEffect(() => {
    const elem = ref?.current;

    if (elem) {
      observer.observe(elem);
    }
    return () => {
      if (elem) {
        observer.disconnect();
      }
    };
  }, [observer, ref]);

  return isIntersecting;
};
